import { IconX } from '@tabler/icons-react-native';
import { presentGuestSignupPromptAtom, presentLoginSheet } from 'app/atoms';
import { BottomSheet } from 'app/design/primitives/bottom-sheet';
import { Column, Row } from 'app/design/primitives/box';
import { Button } from 'app/design/primitives/button';
import { Modal } from 'app/design/primitives/modal';
import { Text } from 'app/design/primitives/text';
import { SignUpSource, useNavigateToSignUpForm } from 'app/screens/onboarding/signup';
import { useTheme } from 'app/shopify';
import { ICON_STROKE_WIDTH } from 'app/utils/constants';
import { useUISize } from 'app/utils/web-helpers';
import { useAtom, useSetAtom } from 'jotai';
import { useTranslation } from 'react-i18next';
import { ScrollView } from 'react-native';
import { DownloadAppSection } from './DownloadAppSection';

export function GuestSignupPrompt() {
  const [open, setOpen] = useAtom(presentGuestSignupPromptAtom);
  const setLoginOpen = useSetAtom(presentLoginSheet);
  const navigateToSignUp = useNavigateToSignUpForm(false, undefined, SignUpSource.Billboard);
  const { isLargeUI } = useUISize();
  const { t } = useTranslation('signup');
  const { t: tCommon } = useTranslation('common');
  const { t: tAccessibility } = useTranslation('accessibility');
  const theme = useTheme();
  const close = () => setOpen(false);
  const content = (
    <>
      <Column
        paddingHorizontal={isLargeUI ? 'spacing.general.x10' : 'spacing.general.x5'}
        paddingVertical="spacing.general.x6"
        gap="spacing.general.x6"
      >
        {isLargeUI ? (
          <Button accessibilityLabel={tAccessibility('close')} onPress={close} alignSelf="flex-end" variant="plain">
            <IconX color={theme.colors['icon.primary']} size={24} strokeWidth={ICON_STROKE_WIDTH} />
          </Button>
        ) : null}
        <Text textAlign="center" variant={isLargeUI ? 'headerMedium' : 'headerSmall'}>
          {t('guestTitle', { appName: tCommon('appName') })}
        </Text>
        <Button
          onPress={() => {
            close();
            navigateToSignUp();
          }}
          style={{ borderRadius: theme.borderRadii['radius.full'] }}
          variant="primary"
          testID="guest-create-account-button"
        >
          {t('guestCreateAccount')}
        </Button>
        <Row justifyContent="center" alignItems="center" gap="spacing.general.x2" flexWrap="wrap">
          <Text color="text.secondary" variant="bodySmall">
            {t('alreadyHaveAccountPrefix')}
          </Text>
          <Button
            onPress={() => {
              close();
              setLoginOpen(true);
            }}
            variant="plain"
            testID="guest-existing-account-button"
          >
            <Text color="text.interactive" fontWeight="600" textDecorationLine="underline">
              {t('alreadyHaveAccount')}
            </Text>
          </Button>
        </Row>
      </Column>
      <DownloadAppSection showQrCodes={false} />
    </>
  );
  if (!isLargeUI)
    return (
      <BottomSheet onClose={close} open={open} showIndicator forceZeroPadding>
        {content}
      </BottomSheet>
    );
  return (
    <Modal animationType="fade" onClose={close} open={open} transparent>
      <Column
        backgroundColor="surface.default"
        borderRadius="radius.lg"
        overflow="hidden"
        maxHeight="90%"
        maxWidth={480}
        width="95%"
      >
        <ScrollView bounces={false} keyboardShouldPersistTaps="handled">
          {content}
        </ScrollView>
      </Column>
    </Modal>
  );
}
